<template>
  <a
    title=""
    data-test="clear-shifts"
    @click="showClearShiftDialog = true">Clear shifts</a>
  <ConfirmationDialog
    v-model="showClearShiftDialog"
    data-test="confirmation-dialog-clear-shifts"
    :is-loading="clearShiftsMutation?.fetching?.value"
    @confirmation-selection="
      (confirm) => (confirm ? clearShifts() : (showClearShiftDialog = false))
    ">
    <template #text-header>
      Clear shifts
    </template>
    <template #text-subtitle>
      <div><strong>{{ currSchedDataIdsStore.currTeamId }} </strong></div>
      <div>{{ currSchedDataIdsStore.currSchedPeriodId }}</div>
    </template>
    <template #text-body>
      This will clear all non-event shifts to an empty code for the entire schedule period, for all users.
      <v-checkbox
        v-model="clearLockedShifts"
        data-test="clear-locked-shifts-checkbox"
        label="Clear locked shifts?"
        color="var(--c-teal)"
        hide-details />
    </template>
    <template #button-abort>
      Cancel
    </template>
    <template #button-confirm>
      Clear
    </template>
  </ConfirmationDialog>
</template>

<script setup lang="ts">
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearMasterShiftsTeamAndPeriodDocument} from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";

const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const clearShiftsMutation = useMutation(ClearMasterShiftsTeamAndPeriodDocument);

const showClearShiftDialog = ref(false);
const clearLockedShifts = ref(false);

async function clearShifts() {
  const result = await clearShiftsMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
    clearLockedShifts: clearLockedShifts.value,
  });

  if (!result.error && !!result.data) {
    toast.success("Shifts have been cleared successfully");
    showClearShiftDialog.value = false;
  } else {
    toast.error("Error has occurred while clearing shifts");
  }
}

</script>
